var map = {
	"./btn_camera_off.png": "d3d6",
	"./btn_camera_on.png": "fd14",
	"./btn_close.png": "9cfb",
	"./btn_mic_off.png": "6e80",
	"./btn_mic_on.png": "bafc",
	"./btn_present_fullwidth.png": "a731",
	"./btn_recent.png": "674e",
	"./btn_start_streaming.png": "d802",
	"./btn_start_streaming_disabled.png": "bf94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a32a";